module.exports = __webpack_public_path__ + "img/facebook.be8c5546.png";